module.exports = __webpack_public_path__ + "img/snappicture_03.4163ef25.jpg";